import { Box, TextField, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import useProfile from '../../../../../../hooks/profile';
import ObjectBus from '../../assets/feedback/passengers/object.svg';
import ObjectTruck from '../../assets/feedback/property/object.svg';

interface ObjectDistanceInputProps {
    enteredDistance: string;
    onDistanceChange: (value: string) => void;
    errorMessage: string;
    localeMinDistance?: number;
    units: string;
}

export const ObjectDistanceInput: React.FC<ObjectDistanceInputProps> = (props) => {
    const { t } = useTranslation();
    const { profile } = useProfile();
    const image = profile.customer.settings.driving_type === 'passengers' ? ObjectBus : ObjectTruck;

    return (
        <Box sx={{ display: 'flex', width: '100%', flexDirection: 'column', alignItems: 'center' }}>
            <img src={image} alt="object" style={{ width: '100%' }} />
            <Typography sx={{ my: 2 }}>
                {t('setup_tool.device_feedback.object_instructions_1', {
                    minDistance: props.localeMinDistance,
                    units: t(`setup_tool.installation_params.units.${props.units}`),
                })}
            </Typography>
            <TextField
                fullWidth
                required
                label={t('setup_tool.device_feedback.object_distance', {
                    units: t(`setup_tool.installation_params.units.${props.units}`),
                })}
                value={props.enteredDistance}
                onChange={(e) => props.onDistanceChange(e.target.value)}
                error={!!props.errorMessage}
                helperText={props.errorMessage}
            />
        </Box>
    );
};
